import { useEffect, useRef, useState } from 'react';
import {
  getMoveOutAssignmentIdFromNotification,
  getMoveOutPropertyIdFromNotification,
  resolveMoveOutAssignmentIdFromHint,
} from '../pages/shared/Notifications/notificationUtils';

function rowAssignmentId(row) {
  return String(row?.assignmentId || row?.id || '');
}

export function useMoveOutRequestFocus(
  navigationState,
  { rows, loadingRows, loadingProperties, properties, setSelectedPropertyId, setActiveStatus }
) {
  const [highlightedAssignmentId, setHighlightedAssignmentId] = useState(null);
  const focusHandledRef = useRef(null);

  useEffect(() => {
    if (loadingProperties || loadingRows) return;

    const hasIntent =
      navigationState?.assignmentId ||
      navigationState?.moveOutResolveHint ||
      navigationState?.focusMoveOutOnly ||
      navigationState?.notification;

    if (!hasIntent) return;

    const idFromNotification = navigationState?.notification
      ? getMoveOutAssignmentIdFromNotification(navigationState.notification)
      : null;
    const propertyIdFromNotification = navigationState?.notification
      ? getMoveOutPropertyIdFromNotification(navigationState.notification)
      : null;

    let targetId = navigationState?.assignmentId || idFromNotification || null;
    const targetPropertyId = navigationState?.propertyId || propertyIdFromNotification || null;

    const handleKey = `${targetId || 'hint'}:${targetPropertyId || ''}:${navigationState?.notification?.id || ''}`;
    if (focusHandledRef.current === handleKey) return;

    setActiveStatus('PENDING');
    if (targetPropertyId && properties.some((p) => String(p.id) === String(targetPropertyId))) {
      setSelectedPropertyId(targetPropertyId);
    }

    let row = targetId
      ? rows.find((r) => rowAssignmentId(r) === String(targetId))
      : null;

    const resolveHint =
      navigationState?.moveOutResolveHint ||
      (navigationState?.notification?.createdAt ? { createdAt: navigationState.notification.createdAt } : null);

    if (!row && !targetId && resolveHint) {
      targetId = resolveMoveOutAssignmentIdFromHint(rows, resolveHint);
      row = targetId ? rows.find((r) => rowAssignmentId(r) === String(targetId)) : null;
    }

    if (!targetId) return;

    focusHandledRef.current = handleKey;
    setHighlightedAssignmentId(String(targetId));

    if (row?.propertyId && properties.some((p) => String(p.id) === String(row.propertyId))) {
      setSelectedPropertyId(row.propertyId);
    }

    window.setTimeout(() => {
      const el = document.querySelector(`[data-move-out-assignment-id="${targetId}"]`);
      if (el) el.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }, 200);
  }, [
    navigationState,
    rows,
    loadingRows,
    loadingProperties,
    properties,
    setSelectedPropertyId,
    setActiveStatus,
  ]);

  return highlightedAssignmentId;
}
